// Chat component
import React, { useState, useRef, useEffect, useContext, useMemo } from "react";
import "./Chat.css";
import {
  Alert,
  Box,
  Button,
  Grid,
  IconButton,
  Snackbar,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import useSignalingStore from "../signalingStore";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Contacts from "./contacts";
import ChatComponent from "./chatComp";
import axios from "axios";
import ButtonAppBar from "components/Navbars/navBar";
import VideoCallInterface from "./VideoCallInterface ";
import VideoCallDisplay from "./VideoCallInterface ";
import { SlCallIn } from "react-icons/sl";
import { HiOutlinePhoneMissedCall } from "react-icons/hi";
import { LuScreenShareOff } from "react-icons/lu";
import { LuScreenShare } from "react-icons/lu";
import { InCallNotification } from "./InCallNotification";
import CallNotification from "./IncomingCallNotification";
import { VideoProvider } from "components/context/VideoContext";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ContactsIcon from "@mui/icons-material/Contacts";
import { COLORS } from "colors/color";
import { fetchUser } from "services/userService";
import VideoCallComponent from "./videoCallComponent";
import useFetchUser from "hooks/useFetchUser";
import { VideoCallContext } from "store/VideoCallContext";
import io from "socket.io-client";
import useUserId from "hooks/useUserId";
import useFetchConversations from "hooks/useFetchConversations";
import { useGetDiscussionUsers } from "hooks/useDiscussionUsers";
import ConversationDialog from "./ConversationDialog";
import IncomingCall from "./IncomingCall";
import { CallersIdContext } from "store/callersIdContext";
import NewAppBar from "components/Navbars/AppBar";
import Footer from "views/Landing/Footer";
import { NewCreateOfferButton } from "components/Buttons/Buttons";
import colors from "colors/color";

const App = () => {
  const localVideoRef = useRef(null);
  const remoteVideoRef = useRef(null);
  const signalingServer = useRef(null);
  const peerConnection = useRef(null);
  const ringAudioRef = useRef(null);
  const historyRef = useRef(null);
  const callTypeRef = useRef("video");
  // const [senderId, setSenderId] = useState("");
  const [receiverId, setReceiverId] = useState("");
  const [callStatus, setCallStatus] = useState("idle");
  const [messages, setMessages] = useState([]);
  const [messagesHistory, setMessagesHistory] = useState([]);

  const [receivedMessages, setReceivedMessages] = useState([]);
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [UsersConv, setUsersConv] = useState([]);
  const [screenSharing, setScreenSharing] = useState(false);
  const screenStreamRef = useRef(null);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const currentDate = new Date();
  const options = { hour: "2-digit", minute: "2-digit" };
  const [isScreenSharing, setIsScreenSharing] = useState(false);
  const screenTrackRef = useRef(null);
  const [updateconv, setupdateconv] = useState(null);
  const [incall, setIncall] = useState([]);
  const callisref = useRef(false);
  const [fileName, setFileName] = useState("");
  // const [conected, setconected] = useState(false);
  const [display, setdisplay] = useState(false);
  const location = useLocation();
  const [callDuration, setCallDuration] = useState("00:00");
  const [notificationCount, setNotificationCount] = useState(0);
  const [searchTerm, setSearchTerm] = useState("");
  const apiUrl = process.env.REACT_APP_API_URL;
  const apiUrlsoket = process.env.REACT_APP_API_URL_SOKET;
  const [convInfo, setConvInfo] = useState([]);
  const [userInfoMap, setUserInfoMap] = useState({});
  const [loadingUserInfo, setLoadingUserInfo] = useState(false);
  const [conversationDates, setConversationDates] = useState({});
  const [error, setError] = useState(null);
  const [notification, setNotification] = useState(false);
  const [inCallNotification, setInCallNotification] = useState(false);
  const [incomingCallNotification, setIncomingCallNotification] =
    useState(false);
  const navigate = useNavigate();
  const [showContacts, setShowContacts] = useState(false);
  const isMobileForHideChat = window.innerWidth <= 900;
  const [display2, setDisplay] = useState(false);
  const [receiverData, setReceiverData] = useState([]);
  const { videoCallLaunched, setVideoCallLaunched } =
    useContext(VideoCallContext);
  const videoCallLaunchedRef = useRef(videoCallLaunched); // Ref to track current value for closures
  const { callers, setCallers } = useContext(CallersIdContext);
  const [fromOtherPage, setFromOtherPage] = useState(false);
  const { formData } = useFetchUser();
  const [showChat, setShowChat] = useState(false);
  const [selectedContactId, setSelectedContactId] = React.useState(null);
  const UserId = useUserId();
  const [dataFetched, setDataFetched] = useState();
  const [choosenContacts, setChoosenContacts] = useState([]);
  const {
    data: contacts,
    loading: discussionLoading,
    error: discussionError,
  } = useGetDiscussionUsers(UserId.userId);

  const {
    data: conversations,
    isLoading,
    isLoadingMore,
    isError,
    refetch,
    hasMore: hasMoreConversations,
    loadMore: loadMoreConversations,
  } = useFetchConversations();
  const [dialogOpen, setDialogOpen] = useState(false);
  const [callModalOpen, setCallModalOpen] = useState(false);
  const [callData, setCallData] = useState(null);
  const [meetingLink, setMeetingLink] = useState("");

  useEffect(() => {
    console.log("userInfo:", formData);
    console.log("User image available:", formData?.image ? "Yes" : "No");
  }, [formData])

  // Ref to track when call last ended (for cooldown period)
  const lastEndedCallTimeRef = useRef(0);

  // Keep ref in sync with state for use in WebSocket closures
  useEffect(() => {
    videoCallLaunchedRef.current = videoCallLaunched;
    console.log("videoCallLaunchedRef updated to:", videoCallLaunched);
    
    // Track when call ends for cooldown
    if (!videoCallLaunched) {
      lastEndedCallTimeRef.current = Date.now();
      console.log("Call ended, setting cooldown timestamp:", lastEndedCallTimeRef.current);
    }
  }, [videoCallLaunched]);

  useEffect(() => {
    console.log("meetingLink:", meetingLink);
  }, [meetingLink]);

  useEffect(() => {
    console.log("fromOtherPage--:", fromOtherPage);
  }, [fromOtherPage]);
  useEffect(() => {
    console.log("1.choosen contacts not empty");
    if (
      choosenContacts &&
      choosenContacts.length > 0
    ) {
      console.log("2.choosen contacts not empty");

      startRinging();
    }
  }, [choosenContacts, meetingLink]);

  // useEffect(()=>{
  //   console.log('formData is :', formData)
  // },[formData])
  useEffect(() => {
    const ringingSocket = connectToSocketRinging(10);

    // Cleanup function to close WebSocket on unmount
    return () => {
      if (ringingSocket && ringingSocket.readyState === WebSocket.OPEN) {
        ringingSocket.close();
      }
    };
  }, []);

  const connectToSocketRinging = (receiver_id) => {
    console.log("1.");
    if (!receiver_id) {
      console.log("2.");

      console.error(
        "Invalid userId or receiver_id for chat WebSocket connection"
      );
      return null;
    }
    console.log("3.");
    const signalingServerUrl3 = `${apiUrlsoket}ws/ring/${receiver_id}/`;
    const newSignalingServer3 = new WebSocket(signalingServerUrl3);

    newSignalingServer3.onmessage = async (message) => {
      try {
        const data = JSON.parse(message.data);
        console.log("Message from server::", data);

        if (data.type === "receiver_ring") {
          // Handle chat message
          console.log("Received ring message:", data.receiver_id);
        }
      } catch (error) {
        console.error("Error processing ringing message:", error);
      }
    };

    // Use the setSignalingServer2 function from the store
    useSignalingStore.getState().setSignalingServer3(newSignalingServer3);

    return newSignalingServer3;
  };

  const handleOpenDialog = () => {
    setDialogOpen(true);
  };

  const handleCloseDialog = () => {
    setDialogOpen(false);
  };

  useEffect(() => {
    console.log("data!", conversations);
    console.log("contacts!", contacts);
  }, [conversations, contacts]);

  const respond = () => {
    navigate("/Chat");
    setVideoCallLaunched(true);
  };
  const calling = () => {
    if (choosenContacts.includes(UserId.userId)) {
      console.log("calling!!", choosenContacts, UserId.userId);
      setNotification(true);
      setCallStatus("ringing");
    }
  };

  useEffect(() => {
    console.log("calling!!", choosenContacts, UserId.userId);

    if (choosenContacts.includes(UserId.userId)) {
      setNotification(true);
      setCallStatus("ringing");
    } else {
      setNotification(false);
      setCallStatus("");
    }
  }, [choosenContacts, UserId.userId]);

  useEffect(() => {
    const fetchReceiverData = async () => {
      try {
        const receiver = await fetchUser(receiverId);
        setReceiverData(receiver);
      } catch (error) {
        console.error("Error fetching receiver data:", error);
      }
    };
    if (receiverId) {
      fetchReceiverData();
    }
  }, [receiverId]);
  useEffect(() => {
    // Show notification based on callStatus
    if (callStatus === "ringing") {
      setNotification(true);
    } else {
      setNotification(false);
    }
  }, [callStatus]);
  useEffect(() => {
    // Show notification based on callStatus
    if (callStatus === "active") {
      setInCallNotification(true);
    } else {
      setInCallNotification(false);
    }
  }, [callStatus]);
  useEffect(() => {
    console.log("conversations data has been updated:", conversations?.length || 0);
    // Use conversations from the hook as the source for filtered conversations
    if (conversations && conversations.length > 0) {
      // Extract user data from conversations for filtering
      const conversationUsers = conversations.map(conversation => ({
        id: conversation.other_user.id,
        first_name: conversation.other_user.first_name,
        last_name: conversation.other_user.last_name,
        company: conversation.other_user.company,
        image: conversation.other_user.image,
      }));

      // Only update UsersConv if conversation IDs have actually changed
      // Fixed: Use stable comparison to prevent infinite re-renders
      setUsersConv(prevUsers => {
        // Check if the user IDs are different
        const prevIds = prevUsers.map(u => u.id).sort().join(',');
        const newIds = conversationUsers.map(u => u.id).sort().join(',');

        if (prevIds !== newIds) {
          return conversationUsers;
        }
        return prevUsers;
      });
    }
  }, [conversations]);

  // Preload full user info (including images) so avatars render immediately
  useEffect(() => {
    if (!UsersConv || UsersConv.length === 0) return;
    const usersNeedingInfo = UsersConv.filter(
      (u) => u && u.id && !userInfoMap[u.id]
    );
    if (usersNeedingInfo.length > 0) {
      getUsersInfo(usersNeedingInfo);
    }
  }, [UsersConv, userInfoMap]);

  // Replace the existing filteredConversations definition with this
  const filteredConversations = useMemo(() => {
    // Deduplicate conversations by user ID first
    const uniqueIds = new Set();
    const deduplicatedUsers = UsersConv.filter(user => {
      if (!user?.id) return false;
      if (uniqueIds.has(user.id)) return false;
      uniqueIds.add(user.id);
      return true;
    });

    // Then apply search filter
    if (searchTerm.trim() === '') {
      return deduplicatedUsers;
    }

    const searchTermLower = searchTerm.toLowerCase();
    return deduplicatedUsers.filter(user => {
      const firstName = (user.first_name || '').toLowerCase();
      const lastName = (user.last_name || '').toLowerCase();
      const fullName = `${firstName} ${lastName}`.trim();
      const company = (user.company || '').toLowerCase();

      return fullName.includes(searchTermLower) ||
        firstName.includes(searchTermLower) ||
        lastName.includes(searchTermLower) ||
        company.includes(searchTermLower);
    });
  }, [UsersConv, searchTerm]);

  const updateCallDuration = (startTime) => {
    const diff = new Date() - startTime;
    const minutes = Math.floor(diff / 60000);
    const seconds = Math.floor((diff % 60000) / 1000);
    setCallDuration(
      `${minutes.toString().padStart(2, "0")}:${seconds
        .toString()
        .padStart(2, "0")}`
    );
  };
  useEffect(() => {
    let interval;
    if (callStatus === "active") {
      const startTime = new Date();
      interval = setInterval(() => updateCallDuration(startTime), 1000);
    }
    return () => {
      if (interval) clearInterval(interval);
    };
  }, [callStatus]);
  const {
    notificationCounts,
    updateNotificationCount,
    resetNotificationCount,
    getTotalNotifications,
    addMessageNotification,
  } = useSignalingStore();
  const totalNotifications = getTotalNotifications();
  const handleFileRemove = () => {
    setSelectedFile(null);
    setFileName(null);
    const fileInput = document.querySelector('input[type="file"]');
    if (fileInput) {
      fileInput.value = "";
    }
  };
  // ICE servers configuration - credentials from environment variables for security
  const iceServers = [
    { urls: "stun:stun.relay.metered.ca:80" },
    {
      urls: "turn:global.relay.metered.ca:80",
      username: process.env.REACT_APP_TURN_USERNAME || "b7ccc598c5ad0d92a7dbc2c2",
      credential: process.env.REACT_APP_TURN_CREDENTIAL || "ujv2zwyoJ0QyKATN",
    },
    {
      urls: "turn:global.relay.metered.ca:80?transport=tcp",
      username: process.env.REACT_APP_TURN_USERNAME || "b7ccc598c5ad0d92a7dbc2c2",
      credential: process.env.REACT_APP_TURN_CREDENTIAL || "ujv2zwyoJ0QyKATN",
    },
    {
      urls: "turn:global.relay.metered.ca:443",
      username: process.env.REACT_APP_TURN_USERNAME || "b7ccc598c5ad0d92a7dbc2c2",
      credential: process.env.REACT_APP_TURN_CREDENTIAL || "ujv2zwyoJ0QyKATN",
    },
    {
      urls: "turns:global.relay.metered.ca:443?transport=tcp",
      username: process.env.REACT_APP_TURN_USERNAME || "b7ccc598c5ad0d92a7dbc2c2",
      credential: process.env.REACT_APP_TURN_CREDENTIAL || "ujv2zwyoJ0QyKATN",
    },
  ];

  const senderId = getUserIdFromAccessToken();
  const userRole = getUserRoleFromAccessToken();
  function getUserRoleFromAccessToken() {
    const accessToken = localStorage.getItem("accessToken");
    if (!accessToken) {
      console.error("No access token found in local storage");
      return null;
    }

    try {
      const decodedToken = parseJwt(accessToken);
      //console.log("Access token : ", decodedToken);
      const role = decodedToken.role;
      return role;
    } catch (error) {
      console.error("Failed to decode access token", error);
      return null;
    }
  }
  function getUserIdFromAccessToken() {
    const accessToken = localStorage.getItem("accessToken");
    if (!accessToken) {
      console.error("No access token found in local storage");
      return null;
    }

    try {
      const decodedToken = parseJwt(accessToken);
      console.log("Decoded token:", decodedToken);

      if (!decodedToken || !decodedToken.user_id) {
        console.error("Invalid token format or missing user_id in token");
        return null;
      }

      const senderId = decodedToken.user_id;
      console.log("Extracted senderId from token:", senderId);
      return senderId;
    } catch (error) {
      console.error("Failed to decode access token", error);
      return null;
    }
  }

  function parseJwt(token) {
    const base64Url = token.split(".")[1];
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split("")
        .map(function (c) {
          return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
        })
        .join("")
    );
    //console.log("payload : ", jsonPayload);

    return JSON.parse(jsonPayload);
  }

  const fetchLastMessageDates = async () => {
    try {
      const response = await axios.get(
        `${apiUrl}messaging/api/last-message-dates/${senderId}/`
      );
      if (response.data) {
        setConversationDates(response.data);
      }
    } catch (error) {
      console.error("Error fetching last message dates:", error);
    }
  };

  useEffect(() => {
    console.log("location ---------", location);

    // Only show the call modal for incomingCall data if NOT coming from another page
    // (when coming from another page, we've already accepted the call)
    if (location.state && location.state.incomingCall && !location.state.fromOtherPage) {
      console.log("Received incoming call data from navigation:", location.state.incomingCall);
      setCallData(location.state.incomingCall);
      setCallModalOpen(true);
    }

    if (location.state && location.state.candidate) {
      console.log("location2 ---------", location);
      console.log(
        "location.state.candidate.candidate_id ---------",
        location.state.candidate.candidate_id
      );
      setSelectedContactId(location.state.candidate.candidate_id);
      setReceiverId(location.state.candidate.candidate_id);
    }

    if (senderId) {
      // Note: Conversation history is now automatically requested by WebSocketManager
      console.log("SenderId available:", senderId, "- WebSocketManager will handle conversation history");
    }

    // Also check for call data on location change
    // Only if we're not coming from another page
    if (!location.state || !location.state.fromOtherPage) {
      checkForStoredCallData();
    }
    if (location.state || location.state?.fromOtherPage) {
      console.log("location.state.fromOtherPage ---------", location.state.fromOtherPage);
      handleCallAction('decline');
      setCallModalOpen(false);
    }
  }, [location, senderId]);

  const socketRef = useRef(null);

  useEffect(() => {
    console.log("the url is  ", apiUrlsoket);
    if (senderId) {
      // Note: General chat WebSocket connection (/ws/chat/${senderId}/0/) is now managed by WebSocketManager
      // This prevents duplicate connections and infinite connection loops
      console.log("SenderId:", senderId, "- Using WebSocketManager for general chat connection");

      // Request conversation history through the global WebSocket connection
      // The WebSocketManager will handle this automatically
      fetchLastMessageDates();

      // Note: WebSocket message handling is now managed by WebSocketManager
    } else {
      console.error("No senderId available for WebSocket connection");
    }
  }, [senderId]);
  // Note: Conversation history requests are now handled by WebSocketManager

  const handleCallStart = () => {
    navigate("/videoCall", {
      state: {
        callDuration,
        display,
        callStatus,
        senderId,
        receiverId,
        isScreenSharing,
        messages,
        setMessage,
        handleFileChange,
        fileName,
        fileempty,
        messagesHistory,
      },
    });
  };
  const getUsersInfo = async (users) => {
    setLoadingUserInfo(true);
    try {
      // Create an array of promises for parallel fetching
      const userInfoPromises = users.map((user) =>
        axios
          .get(`${apiUrl}authentication/user_list/${user.id}/`)
          .catch((error) => {
            console.error(`Error fetching user ${user.id} info:`, error);
            return { data: null }; // Return null data on error
          })
      );

      // Wait for all requests to complete
      const responses = await Promise.all(userInfoPromises);

      // Create a map of user IDs to their full info
      const newUserInfoMap = {};
      responses.forEach((response, index) => {
        if (response.data) {
          const userId = users[index].id;
          newUserInfoMap[userId] = {
            ...users[index],
            ...response.data, // Merge conversation data with user info
          };
        }
      });

      setUserInfoMap((prev) => ({ ...prev, ...newUserInfoMap }));
    } catch (error) {
      console.error("Error fetching users information:", error);
    } finally {
      setLoadingUserInfo(false);
    }
  };

  useEffect(() => {
    console.log("fromOtherPage check:", location.state);

    if (location.state && location.state.fromOtherPage) {
      console.log("Coming from other page, setting up video call:", location.state);

      // Set fromOtherPage to true to prevent showing the call modal
      setFromOtherPage(true);
      setCallModalOpen(false);
      handleCallAction('decline');
      // If we have incoming call data, set it up and launch the video call
      if (location.state.incomingCall) {
        console.log("Call data found in navigation state");
        setCallData(location.state.incomingCall);
        setVideoCallLaunched(true);
        setCallModalOpen(false);

        // Clear the sessionStorage to prevent duplicate notifications
        sessionStorage.removeItem('incomingCallData');
      }
    } else {
      // If we're not coming from another page, make sure fromOtherPage is false
      // so the IncomingCall component can be shown
      setFromOtherPage(false);
    }
  }, [location]);
  // Note: Conversation history is now automatically requested by WebSocketManager

  useEffect(() => {
    scrollToBottom();
  }, [messages, messagesHistory]);

  // Ensure messages are always in chronological order
  useEffect(() => {
    if (messages.length > 0) {
      // Check if sorting is needed (if any timestamp is out of order)
      let needsSorting = false;
      for (let i = 1; i < messages.length; i++) {
        if (new Date(messages[i - 1].timestamp) > new Date(messages[i].timestamp)) {
          needsSorting = true;
          break;
        }
      }

      if (needsSorting) {
        console.log("Re-sorting messages to ensure chronological order");
        setMessages(prevMessages => {
          const sorted = [...prevMessages].sort((a, b) =>
            new Date(a.timestamp) - new Date(b.timestamp)
          );
          return sorted;
        });
      }
    }
  }, [messages.length]);

  useEffect(() => {
    if (senderId && receiverId) {
      console.log("test");
      getHistory();
      connectToSocket(senderId, receiverId);
    }

    return () => {
      // Cleanup: close WebSocket connection and clear messages
      if (signalingServer.current && signalingServer.current.readyState === WebSocket.OPEN) {
        signalingServer.current.close();
      }
      setMessages([]);
      setReceivedMessages([]);
    };
  }, [senderId, receiverId]);

  const scrollToBottom = () => {
    if (historyRef.current) {
      // console.log("is executeeeeeeeeeeeeeeed");
      setTimeout(() => {
        historyRef.current.scrollTop = historyRef.current.scrollHeight;
      }, 100); // 100ms delay
      // console.log("its endeeeed");
    }
  };
  const signalingServer2 = useSignalingStore.getState().signalingServer;
  const sendNotification = (message, sid, rid) => {
    console.log("Sending notification with user image:", {
      hasFormData: !!formData,
      image: formData?.image || "No image available",
      firstName: formData?.first_name,
      lastName: formData?.last_name,
      userId: formData?.id || sid
    });

    if (signalingServer2 && signalingServer2.readyState === WebSocket.OPEN) {
      const notificationData = {
        type: "notif_messages",
        notif: `New message from ${formData.first_name} ${formData.last_name}: ${message.substring(0, 20)}...`,
        receiver_id: rid,
        sender_name: `${formData.first_name} ${formData.last_name}`,
        sender_image: formData.image || null,
        sender_id: formData.id || sid
      };

      console.log("Notification data being sent:", {
        type: notificationData.type,
        sender_name: notificationData.sender_name,
        sender_image: notificationData.sender_image ? "Image present" : "No image",
        receiver_id: notificationData.receiver_id,
        sender_id: notificationData.sender_id
      });

      signalingServer2.send(JSON.stringify(notificationData));
      console.log("Notification sent successfully with image:", formData.image ? "Yes" : "No");
    } else {
      console.log("WebSocket is not connected. Cannot send notification.");
    }
  };
  const ring = (targetUserId) => {
    if (signalingServer2 && signalingServer2.readyState === WebSocket.OPEN) {
      const message = {
        type: "ring",
        targetUserId: targetUserId,
        timestamp: new Date().toISOString(),
      };
      signalingServer2.send(JSON.stringify(message));
      console.log("Ring message sent:", message);
    } else {
      console.error(
        "WebSocket is not open. Ready state:",
        signalingServer2?.readyState
      );
    }
  };
  const handleConversationClick = async (userId) => {
    if (isMobile || videoCallLaunched) {
      setdisplay(true);
      setShowChat(true);
      setSelectedContactId(userId);
    }
    // setdisplay(true);
    // setShowChat(true);
    setReceiverId(userId);
    // setSelectedContactId(userId);
    resetNotificationCount(userId);

    console.log("receiverId", userId);

    try {
      const response = await fetch(
        `${apiUrl}messaging/api/mark-notifications-as-read/`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
          },
          body: JSON.stringify({
            sender_id: userId,
            recipient_id: senderId,
          }),
        }
      );

      if (!response.ok) {
        throw new Error("Failed to mark notifications as read");
      }

      useSignalingStore.getState().resetNotificationCount(userId);
      useSignalingStore.getState().clearMessageNotifications();
    } catch (error) {
      console.error("Error marking notifications as read:", error);
    }

    try {
      const userResponse = await axios.get(`${apiUrl}authentication/user_list/${userId}/`);
      if (userResponse.data) {
        setUserInfoMap((prevUserInfoMap) => ({
          ...prevUserInfoMap,
          [userId]: userResponse.data,
        }));
      }
    } catch (error) {
      console.error(`Error fetching user ${userId} info:`, error);
    }
  };
  const handleBackToContacts = () => {
    setShowChat(false);
    setDisplay(false);
  };
  useEffect(() => {
    const abortController = new AbortController();

    const updateCallStatus = async () => {
      try {
        await fetch(`${apiUrl}messaging/api/end-call/`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
          },
          body: JSON.stringify({ sender_id: senderId }),
          signal: abortController.signal,
        });
      } catch (error) {
        if (error.name !== "AbortError") {
          console.error("Error updating call status:", error);
        }
      }
    };

    updateCallStatus();

    return () => {
      abortController.abort();
    };
  }, [apiUrl, senderId]);

  useEffect(() => {
    const fetchUnreadMessageCounts = async () => {
      try {
        const response = await fetch(
          `${apiUrl}messaging/api/unread-message-counts/`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
            },
          }
        );
        if (!response.ok) {
          throw new Error("Failed to fetch unread message counts");
        }
        const data = await response.json();
        console.log("you unreaded messages ", data);
        useSignalingStore.getState().setInitialNotificationCounts(data);
      } catch (error) {
        console.error("Error fetching unread message counts:", error);
      }
    };
    fetchUnreadMessageCounts();
  }, []);
  const handleMessageSend = () => {
    console.log("Sending message with user image:", {
      hasFormData: !!formData,
      image: formData?.image || "No image available",
      firstName: formData?.first_name,
      lastName: formData?.last_name
    });

    if (
      signalingServer.current &&
      signalingServer.current.readyState === WebSocket.OPEN &&
      message.trim() !== ""
    ) {
      const timestamp = new Date().toISOString();
      const messageData = {
        type: "chat_message",
        message,
        timestamp,
        sender_id: senderId,
        receiver_id: receiverId,
        sender_name: `${formData.first_name} ${formData.last_name}`,
        sender_image: formData.image || null
      };

      console.log("Message data being sent:", {
        type: messageData.type,
        sender_name: messageData.sender_name,
        sender_image: messageData.sender_image ? "Image present" : "No image",
      });

      signalingServer.current.send(JSON.stringify(messageData));

      setMessages((prevMessages) => {
        const newMessages = [
          ...prevMessages,
          {
            content: message,
            timestamp,
            sender: parseInt(senderId),
            recipient: parseInt(receiverId),
          },
        ];

        // Sort messages by timestamp
        return newMessages.sort((a, b) =>
          new Date(a.timestamp) - new Date(b.timestamp)
        );
      });

      sendNotification(message, senderId, receiverId);
      resetNotificationCount(receiverId);

      setMessage("");
      scrollToBottom();
      return true;
    }
    return false;
  };
  useEffect(() => {
    console.log("userId is : ", senderId);

    // Diagnostics disabled - check logs in browser console if needed
    // Uncomment below for debugging:
    /*
    let diagnosticInterval;
    if (process.env.NODE_ENV === 'development') {
      diagnosticInterval = setInterval(() => {
        checkWebSocketConnections();
      }, 10000);
    }

    return () => {
      if (diagnosticInterval) {
        clearInterval(diagnosticInterval);
      }
    };
    */
  }, [senderId]);

  // Function to check all WebSocket connections
  const checkWebSocketConnections = () => {
    console.log("=== WebSocket Connection Diagnostic ===");

    // Check main socket reference
    if (socketRef.current) {
      console.log("Main socket state:", getReadyStateText(socketRef.current.readyState));
    } else {
      console.log("Main socket: Not initialized");
    }

    // Check signaling server
    if (signalingServer.current) {
      console.log("Signaling server state:", getReadyStateText(signalingServer.current.readyState));
    } else {
      console.log("Signaling server: Not initialized");
    }

    // Check signaling server from store
    const signalingServer2 = useSignalingStore.getState().signalingServer;
    if (signalingServer2) {
      console.log("Store signaling server state:", getReadyStateText(signalingServer2.readyState));
    } else {
      console.log("Store signaling server: Not initialized");
    }

    // Check signaling server for ringing
    const signalingServer3 = useSignalingStore.getState().signalingServer3;
    if (signalingServer3) {
      console.log("Ringing signaling server state:", getReadyStateText(signalingServer3.readyState));
    } else {
      console.log("Ringing signaling server: Not initialized");
    }

    // Check token
    const token = localStorage.getItem("accessToken");
    console.log("Access token exists:", !!token);

    console.log("=====================================");
  };

  // Helper to convert WebSocket ready state to text
  const getReadyStateText = (readyState) => {
    switch (readyState) {
      case WebSocket.CONNECTING: return "CONNECTING (0)";
      case WebSocket.OPEN: return "OPEN (1)";
      case WebSocket.CLOSING: return "CLOSING (2)";
      case WebSocket.CLOSED: return "CLOSED (3)";
      default: return "UNKNOWN";
    }
  };

  useEffect(() => {
    console.log("................................incall is ", incall);
  }, [incall]);

  useEffect(() => {
    console.log("senderId", senderId);
    console.log("reciever id", receiverId);
  }, [senderId, receiverId]);

  const toggleScreenShare = async () => {
    if (!isScreenSharing) {
      try {
        const screenStream = await navigator.mediaDevices.getDisplayMedia({
          video: true,
        });
        const screenTrack = screenStream.getTracks()[0];
        screenTrackRef.current = screenTrack;

        const sender = peerConnection.current
          .getSenders()
          .find((s) => s.track && s.track.kind === "video");

        if (sender) {
          sender.replaceTrack(screenTrack);
        }

        screenTrack.onended = () => {
          stopScreenShare();
        };

        setIsScreenSharing(true);
      } catch (error) {
        console.error("Error sharing screen:", error);
      }
    } else {
      stopScreenShare();
    }
  };

  const stopScreenShare = () => {
    if (screenTrackRef.current) {
      screenTrackRef.current.stop();

      // Add null safety checks
      if (localVideoRef.current && localVideoRef.current.srcObject) {
        const localStream = localVideoRef.current.srcObject;
        const localVideoTrack = localStream
          .getTracks()
          .find((track) => track.kind === "video");

        if (peerConnection.current) {
          const sender = peerConnection.current
            .getSenders()
            .find((s) => s.track && s.track.kind === "video");

          if (sender && localVideoTrack) {
            sender.replaceTrack(localVideoTrack);
          }
        }
      }

      screenTrackRef.current = null;
      setIsScreenSharing(false);
    }
  };

  const getHistory = async () => {
    try {
      console.log("Fetching chat history for senderId:", senderId, "receiverId:", receiverId);
      console.log("API URL:", `${apiUrl}messaging/api/chat/${receiverId}/${senderId}/history/?page=1&page_size=10`);

      // Check if we have valid IDs
      if (!senderId || !receiverId) {
        console.error("Missing senderId or receiverId for getHistory");
        return;
      }

      const accessToken = localStorage.getItem("accessToken");
      if (!accessToken) {
        console.error("No access token available for authentication");
        return;
      }

      const response = await fetch(
        `${apiUrl}messaging/api/chat/${receiverId}/${senderId}/history/?page=1&page_size=10`,
        {
          headers: {
            Authorization: `Bearer ${accessToken}`
          }
        }
      );

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`Failed to fetch history: ${response.status} ${response.statusText} - ${errorText}`);
      }
      const result = await response.json();
      console.log("Retrieved chat history:", result.length, "messages");

      // Sort messages by timestamp before setting state
      const sortedMessages = result.sort((a, b) =>
        new Date(a.timestamp) - new Date(b.timestamp)
      );

      setMessagesHistory(sortedMessages);
      console.log("messagesHistory", sortedMessages);
      scrollToBottom();
    } catch (error) {
      console.error("Error fetching history:", error.message);
    }
  };
  useEffect(() => {
    const currentSenderId = getUserIdFromAccessToken();
    if (currentSenderId) {
      connectToSocket(currentSenderId, "0");
    }
    return () => {
      // Cleanup: properly close WebSocket connection
      if (signalingServer.current) {
        if (signalingServer.current.readyState === WebSocket.OPEN ||
          signalingServer.current.readyState === WebSocket.CONNECTING) {
          signalingServer.current.close();
        }
        signalingServer.current = null;
      }
    };
  }, []);
  useEffect(() => {
    console.log("Updated notification count:", notificationCount);
  }, [notificationCount]);
  useEffect(() => {
    console.log("callers::", callers);
  }, [callers]);

  useEffect(() => {
    // This effect only manages the callers array for tracking active callers
    // The call modal is opened in the receiver_ring handler, NOT here
    // Opening the modal here caused race conditions when the call ends
    if (callData && callData.meetingLink && callData.sender_info) {
      console.log("callData:", callData);
      setCallers((prevCallers) => {
        const callerExists = prevCallers.some(
          (caller) =>
            caller.callerId === callData.sender_info.id &&
            caller.roomId === callData.meetingLink
        );
        if (!callerExists) {
          return [
            ...prevCallers,
            {
              callerId: callData.sender_info.id,
              roomId: callData.meetingLink,
            },
          ];
        }
        return prevCallers;
      });
    }
  }, [callData]);
  const connectToSocket = (senderId, receiverId) => {
    const signalingServerUrl = `${apiUrlsoket}ws/chat/${senderId}/${receiverId}/`;
    console.log("Connecting to chat websocket:", signalingServerUrl);
    console.log("SenderId:", senderId, "ReceiverId:", receiverId);

    signalingServer.current = new WebSocket(signalingServerUrl);
    if (receiverId === 0 || receiverId === "0") {
      setdisplay(false);
    } else if (receiverId !== 0 && receiverId !== "0") {
      setdisplay(true);
    }

    signalingServer.current.onopen = () => {
      console.log(
        "Signaling server connected successfully",
        "senderId:",
        senderId,
        "receiverId:",
        receiverId
      );
      console.log("Ready state:", signalingServer.current.readyState);
    };

    signalingServer.current.onerror = (error) => {
      console.error("Chat WebSocket error:", error);
      console.error("Ready state on error:", signalingServer.current.readyState);
    };

    signalingServer.current.onclose = (event) => {
      console.log("Chat WebSocket closed with code:", event.code);
      console.log("Reason:", event.reason || "No reason provided");
    };

    signalingServer.current.onmessage = async (message) => {
      try {
        const data = JSON.parse(message.data);
        console.log("Message from chat server:", data);

        if (data.type === "offer") {
          if (peerConnection.current.signalingState !== "stable") {
            console.error(
              "PeerConnection is not in a stable state:",
              peerConnection.current.signalingState
            );
            return;
          }
          callTypeRef.current = data.callType;
          await peerConnection.current.setRemoteDescription(
            new RTCSessionDescription(data.offer)
          );
          console.log("test");
          setCallStatus("ringing");
          ringAudioRef.current.play();
          console.log("----------in answer ", data.sender_id);
          setupdateconv(data.sender_id);
        } else if (data.type === "answer") {
          if (peerConnection.current.signalingState !== "have-local-offer") {
            console.error(
              "PeerConnection is not in a state to accept an answer:",
              peerConnection.current.signalingState
            );
            return;
          }
          await peerConnection.current.setRemoteDescription(
            new RTCSessionDescription(data.answer)
          );
          console.log("test2", data);
          setCallStatus("active");
        } else if (data.type === "ice_candidate") {
          try {
            await peerConnection.current.addIceCandidate(
              new RTCIceCandidate(data.candidate)
            );
          } catch (error) {
            console.error("Failed to add ICE candidate:", error);
          }
        } else if (data.type === "conversation_users_history") {
          setUsersConv(data.users);
          setLoading(false);
        } else if (data.type === "call_ended") {
          callisref.current = false;
          endCall();
        } else if (data.type === "chat_message") {
          console.log("data message is: ", data.timestamp);

          setMessages((prevMessages) => {
            const newMessages = [
              ...prevMessages,
              {
                content: data.message,
                timestamp: data.timestamp,
                sender: parseInt(data.sender_id),
                recipient: parseInt(data.receiver_id),
              },
            ];

            // Sort messages by timestamp
            return newMessages.sort((a, b) =>
              new Date(a.timestamp) - new Date(b.timestamp)
            );
          });

          updateNotificationCount(
            data.sender_id,
            (notificationCounts[data.sender_id] || 0) + 1
          );
          addMessageNotification({
            id: Date.now(),
            message: data.message,
          });
        } else if (data.type === "file_message") {
          console.log("Received file message:", data);
          setMessages((prevMessages) => {
            const newMessages = [
              ...prevMessages,
              {
                type: "file_message",
                fileName: data.fileName,
                fileType: data.fileType,
                fileData: data.fileData,
                sender: parseInt(data.sender_id),
                recipient: parseInt(data.receiver_id),
                timestamp: data.timestamp || new Date().toISOString(),
              },
            ];

            // Sort messages by timestamp
            return newMessages.sort((a, b) =>
              new Date(a.timestamp) - new Date(b.timestamp)
            );
          });

          updateNotificationCount(
            data.sender_id,
            (notificationCounts[data.sender_id] || 0) + 1
          );
          addMessageNotification({
            id: Date.now(),
            message: data.message,
          });
        } else if (data.type === "user_state_change") {
          // setconected(true);
        } else if (data.type === "receiver_ring") {
          console.log("Received ring message:", data);
          console.log("Current videoCallLaunchedRef.current:", videoCallLaunchedRef.current);
          
          // Check cooldown period (2 seconds after leaving a call)
          const timeSinceLastEnd = Date.now() - lastEndedCallTimeRef.current;
          const COOLDOWN_MS = 2000; // 2 seconds
          
          if (timeSinceLastEnd < COOLDOWN_MS) {
            console.log(`Ignoring ring - still in cooldown period (${timeSinceLastEnd}ms since last call ended)`);
            return;
          }
          
          // Only show the call modal if NOT already in a video call
          // Use ref to get current value (avoids stale closure issue)
          if (!videoCallLaunchedRef.current) {
            setCallData(data);
            setCallModalOpen(true);
            sessionStorage.setItem('incomingCallData', JSON.stringify(data));
          } else {
            console.log("Already in a video call, ignoring incoming ring");
          }
        } else if (data.type === "end_ring") {
          console.log("end_ring ring message:", data);
          // Clear any existing call notifications when the call ends
          setCallModalOpen(false);
          setCallData(null);
          sessionStorage.removeItem('incomingCallData');
          
          // Reset meeting link to ensure clean state for next call
          setMeetingLink("");
          setFromOtherPage(false);
          
          // Clear location state
          window.history.replaceState({}, document.title);

          // Stop any playing ring tones
          if (ringAudioRef && ringAudioRef.current) {
            ringAudioRef.current.pause();
            ringAudioRef.current.currentTime = 0;
          }

          // If in a call that was just ended, update UI
          if (videoCallLaunched) {
            setVideoCallLaunched(false);

            toast.info("The call has ended.", {
              position: "top-center",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
            });
          }
        } else if (data.type === "call_rejected") {
          console.log("Call rejected message:", data);
          // Handle when the other party rejects our call
          toast.info("Your call was declined.", {
            position: "top-center",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          });

          // Always clean up call state when rejected
          setMeetingLink("");
          setCallData(null);
          setFromOtherPage(false);
          sessionStorage.removeItem('incomingCallData');
          
          // Clear location state
          window.history.replaceState({}, document.title);

          if (videoCallLaunched) {
            setVideoCallLaunched(false);
          }
        }
      } catch (error) {
        console.error("Error processing message:", error);
      }
    };

    peerConnection.current = new RTCPeerConnection({ iceServers });

    peerConnection.current.onicecandidate = (event) => {
      if (
        event.candidate &&
        signalingServer.current.readyState === WebSocket.OPEN
      ) {
        signalingServer.current.send(
          JSON.stringify({
            type: "ice_candidate",
            candidate: event.candidate,
            sender_id: senderId,
            receiver_id: receiverId,
          })
        );
      }
    };

    peerConnection.current.ontrack = (event) => {
      remoteVideoRef.current.srcObject = event.streams[0];
    };
  };

  const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

  const startLocalStream = async () => {
    console.log("att the start of startlocal stream");
    signalingServer.current.send(
      JSON.stringify({
        type: "handele_check_if_busy",
        sender_id: senderId,
        receiver_id: receiverId,
      })
    );
    console.log("after the send handele_check_if_busy");
    await delay(3000);
    if (callisref.current) {
      console.log("busy");
      toast.info("The user you're trying to call is currently busy.", {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      return;
    }

    if (!peerConnection.current) {
      peerConnection.current = new RTCPeerConnection({ iceServers });
    }

    if (!signalingServer.current) {
      signalingServer.current = new WebSocket(
        `${apiUrlsoket}ws/chat/${senderId}/${receiverId}/`
      );
    }

    const localStream = await navigator.mediaDevices.getUserMedia({
      video: true,
      audio: true,
    });
    localVideoRef.current.srcObject = localStream;
    localStream
      .getTracks()
      .forEach((track) => peerConnection.current.addTrack(track, localStream));

    const offer = await peerConnection.current.createOffer();
    await peerConnection.current.setLocalDescription(offer);
    signalingServer.current.send(
      JSON.stringify({
        type: "offer",
        offer: offer,
        sender_id: senderId,
        receiver_id: receiverId,
        callType: "video",
      })
    );
    setCallStatus("active");
    handleCallStart();
  };
  const startRinging = async () => {
    console.log("At the start of ringing stream");

    choosenContacts.forEach((contactId) => {
      signalingServer.current.send(
        JSON.stringify({
          type: "ring",
          // sender_id: senderId,
          meetingLink: meetingLink,
          sender_info: formData,
          receiver_id: contactId,
        })
      );
    });

    console.log("After sending rings to all contacts");
  };

  const end_Call = async () => {
    console.log("At the start of ringing stream");

    choosenContacts.forEach((contactId) => {
      signalingServer.current.send(
        JSON.stringify({
          type: "end_call",
          // sender_id: senderId,
          meetingLink: meetingLink,
          sender_info: formData,
          receiver_id: contactId,
        })
      );
    });

    console.log("After sending rings to all contacts");
  };

  const startLocalAudioStream = async () => {
    callTypeRef.current = "audio";

    console.log("att the start of startlocal stream");

    signalingServer.current.send(
      JSON.stringify({
        type: "handele_check_if_busy",

        sender_id: senderId,

        receiver_id: receiverId,
      })
    );

    console.log("after the send handele_check_if_busy");

    await delay(3000);

    if (callisref.current) {
      console.log("busy");

      return;
    }

    if (!peerConnection.current) {
      peerConnection.current = new RTCPeerConnection({ iceServers });
    }

    if (!signalingServer.current) {
      signalingServer.current = new WebSocket(
        `${apiUrlsoket}ws/chat/${senderId}/${receiverId}/`
      );
    }

    const localStream = await navigator.mediaDevices.getUserMedia({
      audio: true,
    });
    localVideoRef.current.srcObject = localStream;
    localStream
      .getTracks()
      .forEach((track) => peerConnection.current.addTrack(track, localStream));

    const offer = await peerConnection.current.createOffer();
    await peerConnection.current.setLocalDescription(offer);
    signalingServer.current.send(
      JSON.stringify({
        type: "offer",
        offer: offer,
        sender_id: senderId,
        callType: "audio",
        receiver_id: receiverId,
      })
    );
    setCallStatus("active");
  };

  const stopScreenSharing = () => {
    screenStreamRef.current.getTracks().forEach((track) => track.stop());
    screenStreamRef.current = null;
    setScreenSharing(false);
  };

  const acceptCall = async () => {
    console.log(
      "Accepting call with senderId:",
      senderId,
      "receiverId:",
      receiverId,
      "new is ",
      updateconv
    );
    {
      console.log("Rendering with messagesHistory:", messagesHistory);
    }
    getHistory();
    ringAudioRef.current.pause();
    ringAudioRef.current.currentTime = 0;

    setIncomingCallNotification(false);
    setInCallNotification(true);

    const localStream = await navigator.mediaDevices.getUserMedia({
      video: callTypeRef.current === "video",
      audio: true,
    });
    localVideoRef.current.srcObject = localStream;
    localStream
      .getTracks()
      .forEach((track) => peerConnection.current.addTrack(track, localStream));

    const answer = await peerConnection.current.createAnswer();
    await peerConnection.current.setLocalDescription(answer);
    if (updateconv) {
      setReceiverId(updateconv);
      signalingServer.current.send(
        JSON.stringify({
          type: "answer",
          answer: answer,
          sender_id: senderId,
          receiver_id: updateconv,
          incall: [senderId, updateconv],
        })
      );
    } else {
      signalingServer.current.send(
        JSON.stringify({
          type: "answer",
          answer: answer,
          sender_id: senderId,
          receiver_id: receiverId,
          incall: [senderId, receiverId],
        })
      );
    }

    setCallStatus("active");
    console.log("---senderId ", typeof senderId);
    setIncall((prevIncall) => [...prevIncall, parseInt(senderId)]);

    console.log("---receiverId ", typeof receiverId);
    setIncall((prevIncall) => [...prevIncall, receiverId]);

    console.log("incall is ", incall);
  };

  const endCall = () => {
    if (localVideoRef.current && localVideoRef.current.srcObject) {
      localVideoRef.current.srcObject
        .getTracks()
        .forEach((track) => track.stop());
      localVideoRef.current.srcObject = null;
    }

    if (peerConnection.current) {
      peerConnection.current.close();
      peerConnection.current = null;
    }

    if (signalingServer.current) {
      const targetId = updateconv || receiverId;
      if (signalingServer.current.readyState === WebSocket.OPEN) {
        signalingServer.current.send(
          JSON.stringify({
            type: "call_ended",
            sender_id: senderId,
            receiver_id: targetId,
          })
        );
      }
      setCallDuration("00:00");

      setIncomingCallNotification(false);
      setInCallNotification(false);
      setIsScreenSharing(false);
      setFromOtherPage(false);

      // Clear location state
      window.history.replaceState({}, document.title);

      // Clear any stored call data
      sessionStorage.removeItem('incomingCallData');

      signalingServer.current.close();
      signalingServer.current = null;
    }

    if (ringAudioRef.current) {
      ringAudioRef.current.pause();
      ringAudioRef.current.currentTime = 0;
    }

    if (screenSharing) {
      stopScreenShare();
    }

    callisref.current = false;
    setReceiverId(updateconv || receiverId);
    setTimeout(() => {
      connectToSocket(senderId, receiverId);
    }, 1000);
    setCallStatus("idle");
  };

  // Reduced from 500MB to 10MB for WebSocket safety and browser memory constraints
  const MAX_FILE_SIZE = 10 * 1024 * 1024;

  const [selectedFile, setSelectedFile] = useState(null);

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      if (file.size > MAX_FILE_SIZE) {
        alert(
          `File is too large. Maximum size is ${MAX_FILE_SIZE / 1024 / 1024}MB.`
        );
        event.target.value = null;
        setSelectedFile(null);
        setFileName(null);
      } else {
        setSelectedFile(file);
        setFileName(file.name);
      }
    }
  };
  const handleKeyDown = (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      handleMessageSend();
      handleFileUpload();
    }
  };

  const fileempty = () => {
    setSelectedFile(null);
    setFileName(null);
  };

  const handleFileUpload = () => {
    if (selectedFile) {
      const reader = new FileReader();
      reader.onload = (e) => {
        try {
          const fileData = e.target.result;
          const fileMessage = {
            type: "file_message",
            fileName: selectedFile.name,
            fileType: selectedFile.type,
            fileData: fileData,
            sender_id: senderId,
            receiver_id: receiverId,
            timestamp: new Date().toISOString(),
          };

          if (signalingServer.current && signalingServer.current.readyState === WebSocket.OPEN) {
            signalingServer.current.send(JSON.stringify(fileMessage));

            setMessages((prevMessages) => {
              const newMessages = [
                ...prevMessages,
                {
                  type: "file_message",
                  fileName: selectedFile.name,
                  fileType: selectedFile.type,
                  fileData: fileData,
                  sender: parseInt(senderId),
                  recipient: parseInt(receiverId),
                  timestamp: new Date().toISOString(),
                },
              ];

              // Sort messages by timestamp
              return newMessages.sort((a, b) =>
                new Date(a.timestamp) - new Date(b.timestamp)
              );
            });

            setSelectedFile(null);
            setFileName(null);
          } else {
            console.error("WebSocket is not connected. Cannot send file.");
            toast.error("Unable to send file. Connection lost.", {
              position: "top-center",
              autoClose: 3000,
            });
          }
        } catch (error) {
          console.error("Error uploading file:", error);
          toast.error("Failed to upload file.", {
            position: "top-center",
            autoClose: 3000,
          });
        }
      };

      reader.onerror = (error) => {
        console.error("Error reading file:", error);
        toast.error("Failed to read file.", {
          position: "top-center",
          autoClose: 3000,
        });
      };

      reader.readAsDataURL(selectedFile);
    }
  };
  const renderMessage = (msg) => {
    const isFileMessage =
      msg.file_name || msg.fileName || msg.type === "file_message";
    const fileName = msg.file_name || msg.fileName;
    const fileType = msg.file_type || msg.fileType;
    const fileData = msg.file_data || msg.fileData;

    if (isFileMessage) {
      if (fileType && fileType.startsWith("image/")) {
        return (
          <img
            src={fileData}
            alt={fileName}
            style={{ maxWidth: "200px", maxHeight: "200px", cursor: "pointer" }}
            onClick={() => window.open(fileData, "_blank")}
          />
        );
      } else {
        return (
          <a href={fileData} download={fileName}>
            Download {fileName}
          </a>
        );
      }
    } else {
      return <div className="message-text">{msg.content}</div>;
    }
  };

  const creatGroupLink = async () => {
    try {
      const response = await fetch(
        `${apiUrl}messaging/api/chat/${receiverId}/${senderId}/creatgroup/`
      );
      if (!response.ok) throw new Error("Failed to fetch history");
      const result = await response.json();
    } catch (error) { }
  };
  const [isAuth, setIsAuth] = useState(false);
  const handleCallAction = (action) => {
    setCallModalOpen(false);

    // Validate call data
    if (!callData || !callData.sender_info || !callData.sender_info.id) {
      console.error("Invalid call data in handleCallAction, cleaning up");
      sessionStorage.removeItem('incomingCallData');
      setCallData(null);
      return;
    }

    // Stop any playing ring tones
    if (ringAudioRef && ringAudioRef.current) {
      ringAudioRef.current.pause();
      ringAudioRef.current.currentTime = 0;
    }

    // Stop any temporary ring audio
    if (window._tempRingAudio) {
      window._tempRingAudio.pause();
      window._tempRingAudio.currentTime = 0;
      window._tempRingAudio = null;
    }

    // Stop global ring audio if playing
    const globalRingAudio = document.querySelector('audio[src*="messenger_video_call.mp3"]');
    if (globalRingAudio) {
      globalRingAudio.pause();
      globalRingAudio.currentTime = 0;
    }

    if (action === "accept") {
      // Handle call acceptance - launch video call
      console.log("%cCall accepted, launching video call with data:", "color: green; font-weight: bold;", callData);

      // Mark the call as handled in session storage
      const updatedCallData = {
        ...callData,
        handledByChat: true,
        accepted: true,
        timestamp: new Date().toISOString() // Update timestamp to track when it was accepted
      };
      sessionStorage.setItem('incomingCallData', JSON.stringify(updatedCallData));

      // Launch the video call
      setVideoCallLaunched(true);
      setFromOtherPage(false);
      sessionStorage.removeItem('incomingCallData');

      // Clear location state
      window.history.replaceState({}, document.title);

      // If there's a meeting link, use it
      if (callData.meetingLink) {
        setMeetingLink(callData.meetingLink);
      }
    } else {
      // Handle call rejection - clear call data
      console.log("%cCall rejected", "color: orange; font-weight: bold;");

      // Clean up call data completely
      sessionStorage.removeItem('incomingCallData');
      setCallData(null);
      setFromOtherPage(false);
      
      // Reset meeting link to ensure clean state for next call
      setMeetingLink("");

      // Clear location state
      window.history.replaceState({}, document.title);

      // If we need to notify the caller that the call was rejected
      if (signalingServer.current && signalingServer.current.readyState === WebSocket.OPEN && callData && callData.sender_info) {
        try {
          signalingServer.current.send(
            JSON.stringify({
              type: "call_rejected",
              sender_id: UserId.userId,
              receiver_id: callData.sender_info.id,
              timestamp: new Date().toISOString()
            })
          );
          console.log("Sent call rejection notification to caller");
        } catch (error) {
          console.error("Error sending call rejection:", error);
        }
      }
    }
  };
  useEffect(() => {
    if (localStorage.getItem("accessToken")) {
      setIsAuth(true);
    } else {
      setIsAuth(false);
    }
  }, []);
  const myPaddingTop = (() => {
    if (userRole === "c") {
      return isMobile ? "21%" : "2%";
    } else {
      return isMobile ? "3%" : "0%";
    }
  })();
  const myHeight = (() => {
    if (userRole === "c") {
      return isMobile ? "63vh" : "80vh";
    } else {
      return isMobile ? "73vh" : "83vh";
    }
  })();

  useEffect(() => {
    // Listen for incoming call events when already in Chat component
    const handleIncomingCallInChat = (event) => {
      console.log("%cChat component received incomingCallInChat event", "color: green; font-weight: bold;", event.detail);

      // Don't show the modal if already in a video call
      if (videoCallLaunched) {
        console.log("Already in a video call, ignoring incomingCallInChat event");
        return;
      }

      // Validate call data
      const callData = event.detail;
      if (!callData || !callData.sender_info || !callData.sender_info.id) {
        console.error("Chat component received invalid call data, ignoring");
        return;
      }

      // Play the ring tone to alert the user
      try {
        // Try to use the component's ring audio first
        if (ringAudioRef && ringAudioRef.current) {
          ringAudioRef.current.play()
            .catch(err => console.error("Error playing component ring sound:", err));
        } else {
          // Fallback to a new audio element if the ref isn't available
          const audio = new Audio('/assets/img/messenger_video_call.mp3');
          audio.loop = true;
          audio.play()
            .catch(err => console.error("Error playing fallback ring sound:", err));

          // Store the audio element to stop it later
          window._tempRingAudio = audio;
        }
      } catch (error) {
        console.error("Error playing ring sound:", error);
      }

      // Mark the call as being handled by Chat
      try {
        sessionStorage.setItem('incomingCallData', JSON.stringify({
          ...callData,
          handledByChat: false // We'll mark it as true after the user responds
        }));
      } catch (error) {
        console.error("Error updating call data in sessionStorage:", error);
      }

      // Show call notification modal
      setCallData(callData);
      setCallModalOpen(true);
      console.log("%cShowing call modal in Chat component", "color: green; font-weight: bold;");

      // Explicitly set fromOtherPage to false since we're already in Chat
      setFromOtherPage(false);
    };

    // Add event listener for incoming calls while in Chat
    window.addEventListener('incomingCallInChat', handleIncomingCallInChat);
    console.log("Chat component: Added event listener for incomingCallInChat events");

    // Check for call data on mount
    checkForStoredCallData();

    return () => {
      window.removeEventListener('incomingCallInChat', handleIncomingCallInChat);

      // Clean up any temporary audio
      if (window._tempRingAudio) {
        window._tempRingAudio.pause();
        window._tempRingAudio.currentTime = 0;
        window._tempRingAudio = null;
      }
    };
  }, []);

  // Function to check for stored call data
  const checkForStoredCallData = () => {
    // Don't show the modal if already in a video call
    if (videoCallLaunched) {
      console.log("Already in a video call, not showing call modal");
      return;
    }

    // If we're coming from another page, don't show the call modal
    if (location.state && location.state.fromOtherPage) {
      console.log("Coming from other page, not showing call modal");
      return;
    }

    const storedCallData = sessionStorage.getItem('incomingCallData');
    if (storedCallData) {
      try {
        const parsedCallData = JSON.parse(storedCallData);
        console.log("Chat component: Found stored call data in sessionStorage:", parsedCallData);

        // Validate call data to prevent ghost calls
        if (!parsedCallData || !parsedCallData.sender_info || !parsedCallData.sender_info.id) {
          console.error("Chat component: Found invalid call data, clearing");
          sessionStorage.removeItem('incomingCallData');
          return;
        }

        // If the call was already accepted or handled, don't show the modal
        if (parsedCallData.accepted || parsedCallData.handledByChat) {
          console.log("Call already accepted or handled, not showing modal");
          // Clean up stale data
          sessionStorage.removeItem('incomingCallData');
          return;
        }

        // Mark as handled
        parsedCallData.handledByChat = true;
        sessionStorage.setItem('incomingCallData', JSON.stringify(parsedCallData));

        // Show the call modal
        setCallData(parsedCallData);
        setCallModalOpen(true);
      } catch (error) {
        console.error("Error parsing stored call data:", error);
        sessionStorage.removeItem('incomingCallData');
      }
    }
  };

  return (
    <VideoProvider>
      {userRole == "c" ? <NewAppBar isAuth={isAuth} /> : ""}
      <div
        className={`content App ${callStatus === "active" ? "call-active" : ""
          }`}
        style={{ paddingTop: myPaddingTop }}
      >
        {/* {userRole == "c" ? <ButtonAppBar isAuth={isAuth} /> : ""} */}
        <ToastContainer />
        {callData && callData.sender_info && callData.sender_info.id && !fromOtherPage
          // && callData.timestamp 
          ? (
            <IncomingCall
              open={callModalOpen}
              onClose={handleCallAction}
              callData={callData}
            />
          ) : null}

        <Grid
          container
          sx={{
            height: myHeight,
          }}
        >
          <Grid
            sx={{
              paddingBottom: "2%",
            }}
          >
            {/* Mobile Toggle Button */}
            {isMobile && display2 && userRole !== "c" && (
              <Button
                onClick={() => setDisplay(!display2)}
                startIcon={<ArrowBackIcon />}
                variant="outlined"
                fullWidth
                className="mb-2"
                sx={{
                  color: "#fff",
                  borderRadius: "30px",
                  backgroundColor: COLORS.button_color,
                  textTransform: "none",
                  px: 1,
                  width: "200.44px",
                  height: "50.79px",
                  fontFamily: "Poppins",
                  fontSize: "1.1rem",
                  // marginBottom:'2%',

                  // boxShadow: "0 4px 8px rgba(0, 0, 2, 0.2)",
                }}
              >
                Back to Contacts
              </Button>
            )}
          </Grid>

          {/* Contacts Component */}
          <Grid
            item
            xs={12}
            md={4}
            sx={{
              height: "100%",
              zIndex: "1000",
              display: callStatus === "active" ? "none" : "block",
              [theme.breakpoints.down("md")]: {
                display: !isMobile || !display2 ? "block" : "none",
              },
            }}
          >
            {/* If a contact is selected, show ChatComponent; otherwise, show Contacts */}
            {selectedContactId && videoCallLaunched ? (
              <Box sx={{
                margin: 1,
                height: "calc(100% - 16px)", // Account for the margin
                display: "flex",
                flexDirection: "column",
                overflow: "hidden", // Hide overflow at container level
              }}>
                {/* Back to Contacts Button */}
                <NewCreateOfferButton
                  onClick={() => setSelectedContactId(null)} // Back to Contacts view
                  startIcon={<ArrowBackIcon />}
                  variant="outlined"
                  fullWidth
                  className="mb-2"
                  sx={{
                    color: `${colors.primary}`,
                    // borderRadius: "30px",
                    backgroundColor: 'white',
                    textTransform: "none",
                    px: 1,
                    width: "200.44px",
                    height: "50.79px",
                    fontFamily: "Poppins",
                    fontSize: "1.1rem",
                    flexShrink: 0, // Prevent button from shrinking
                    marginBottom: 1
                  }}
                >
                  Back to Contacts
                </NewCreateOfferButton>

                {/* ChatComponent for the selected contact */}
                <Box sx={{
                  flexGrow: 1,
                  overflow: "auto", // Enable scrolling for this container
                  height: "calc(100% - 60px)",// Subtract button height + margin

                }}>
                  <ChatComponent
                    userInfo={userInfoMap[selectedContactId]} // Pass selected contact's user info
                    display={display}
                    callStatus={callStatus}
                    senderId={senderId}
                    receiverId={selectedContactId} // Use selected contact ID as the receiver ID
                    callTypeRef={callTypeRef}
                    startLocalStream={startLocalStream}
                    startLocalAudioStream={startLocalAudioStream}
                    acceptCall={acceptCall}
                    endCall={endCall}
                    toggleScreenShare={toggleScreenShare}
                    ringAudioRef={ringAudioRef}
                    isScreenSharing={isScreenSharing}
                    renderMessage={renderMessage}
                    historyRef={historyRef}
                    messages={messages}
                    setMessage={setMessage}
                    handleFileChange={handleFileChange}
                    fileName={fileName}
                    fileempty={fileempty}
                    messagesHistory={messagesHistory}
                    setMessagesHistory={setMessagesHistory}
                    handleKeyDown={handleKeyDown}
                    handleMessageSend={handleMessageSend}
                    handleFileUpload={handleFileUpload}
                    handleFileRemove={handleFileRemove}
                    signalingServer={signalingServer}
                    receiverData={receiverData}
                    setVideoCallLaunched={setVideoCallLaunched}
                    callData={callData}
                    setCallData={setCallData}
                  />
                </Box>
              </Box>
            ) : (
              // Contacts Component
              <Contacts
                callStatus={callStatus}
                loading={loading}
                searchTerm={searchTerm}
                setSearchTerm={setSearchTerm}
                senderId={senderId}
                handleConversationClick={
                  videoCallLaunched
                    ? (contactId) => {
                      setSelectedContactId(contactId); // Select a contact and show the chat view
                    }
                    : handleConversationClick
                }
                notificationCount={notificationCount}
                filteredConversations={filteredConversations.map((conv) => ({
                  ...conv,
                  ...userInfoMap[conv.id],
                }))}
                conversations={conversations.filter((conversation) =>
                  filteredConversations.some(
                    (conv) => conv.id === conversation.other_user.id
                  )
                )}
                loadMoreConversations={loadMoreConversations}
                hasMoreConversations={hasMoreConversations}
                isLoadingMore={isLoadingMore}
              />
            )}
          </Grid>
          {/* Chat Component - 60% on desktop, 100% on mobile when chat is selected */}
          <Grid
            item
            xs={12}
            md={8}
            sx={{
              height: "100%",
              display: callStatus === "active" ? "block" : "block",
              marginTop: 2,
              [theme.breakpoints.down("md")]: {
                display: isMobile && display2 ? "block" : "none",
              },
            }}
          >
            {videoCallLaunched && !isMobile ? (
              <VideoCallComponent
                setVideoCallLaunched={setVideoCallLaunched}
                setSelectedContactId={setSelectedContactId}
                handleMessageSend={handleMessageSend}
                setMessage={setMessage}
                senderId={senderId}
                receiverId={receiverId}
                formData={formData}
                choosenContacts={choosenContacts}
                meetingLink={meetingLink}
                setMeetingLink={setMeetingLink}
                callData={callData}
                end_Call={end_Call}
                setCallData={setCallData}
                setFromOtherPage={setFromOtherPage}
                setCallModalOpen={setCallModalOpen}
              />
            ) : (
              <ChatComponent
                userInfo={userInfoMap[receiverId]}
                display={display}
                callStatus={callStatus}
                senderId={senderId}
                receiverId={receiverId}
                callTypeRef={callTypeRef}
                startLocalStream={startLocalStream}
                startLocalAudioStream={startLocalAudioStream}
                acceptCall={acceptCall}
                endCall={endCall}
                toggleScreenShare={toggleScreenShare}
                ringAudioRef={ringAudioRef}
                isScreenSharing={isScreenSharing}
                renderMessage={renderMessage}
                historyRef={historyRef}
                messages={messages}
                setMessage={setMessage}
                handleFileChange={handleFileChange}
                fileName={fileName}
                fileempty={fileempty}
                messagesHistory={messagesHistory}
                setMessagesHistory={setMessagesHistory}
                handleKeyDown={handleKeyDown}
                handleMessageSend={handleMessageSend}
                handleFileUpload={handleFileUpload}
                handleFileRemove={handleFileRemove}
                signalingServer={signalingServer}
                receiverData={receiverData}
                setVideoCallLaunched={setVideoCallLaunched}
                handleOpenDialog={handleOpenDialog}
              />
            )}
          </Grid>
          {userRole === "c" ? <Footer /> : ""}
        </Grid>
        {/* Ring Audio */}
        {ringAudioRef && (
          <audio
            ref={ringAudioRef}
            // Use a reliable audio source format that browsers support widely
            src="./assets/img/messenger_video_call.mp3"
            preload="auto"
            loop
          >
            {/* Fallback sources for better browser compatibility */}
            {/* <source 
            src="https://res.cloudinary.com/dwckvxlca/video/upload/v1710861445/calling-sound_qp8mfe.mp3" 
            type="audio/mpeg" 
          />
          <source 
            src="https://res.cloudinary.com/dwckvxlca/video/upload/v1710861445/calling-sound_qp8mfe.ogg" 
            type="audio/ogg" 
          /> */}
            Your browser does not support the audio element.
          </audio>
        )}
        {/* Snackbar for Notification */}
        <CallNotification
          open={notification}
          onClose={() => setNotification(false)}
          acceptCall={respond}
          endCall={endCall}
          callTypeRef={callTypeRef}
          toggleScreenShare={toggleScreenShare}
          isScreenSharing={isScreenSharing}
          message="Incoming Call"
        />
        <InCallNotification
          open={inCallNotification}
          onClose={() => setInCallNotification(false)}
          acceptCall={acceptCall}
          endCall={endCall}
          callTypeRef={callTypeRef}
          toggleScreenShare={toggleScreenShare}
          isScreenSharing={isScreenSharing}
          setInCallNotification={setInCallNotification}
          inCallNotification={inCallNotification}
          message="Call"
        />

        {/* Mobile Video Call Overlay - Rendered outside grid system for proper z-index */}
        {videoCallLaunched && isMobile && (
          <VideoCallComponent
            setVideoCallLaunched={setVideoCallLaunched}
            setSelectedContactId={setSelectedContactId}
            handleMessageSend={handleMessageSend}
            setMessage={setMessage}
            senderId={senderId}
            receiverId={receiverId}
            formData={formData}
            choosenContacts={choosenContacts}
            meetingLink={meetingLink}
            setMeetingLink={setMeetingLink}
            callData={callData}
            end_Call={end_Call}
            setCallData={setCallData}
            setFromOtherPage={setFromOtherPage}
            setCallModalOpen={setCallModalOpen}
          />
        )}
      </div>
      <ConversationDialog
        open={dialogOpen}
        onClose={handleCloseDialog}
        conversations={contacts}
        isLoading={isLoading}
        isError={isError}
        refetch={refetch}
        setVideoCallLaunched={setVideoCallLaunched}
        calling={calling}
        setChoosenContacts={setChoosenContacts}
        receiverId={receiverId}
      />
    </VideoProvider>
  );
};

export default App;